import { createAction, props } from '@ngrx/store';
import { Jobtype } from '../models/jobtype.model';

export const setJobtypes = createAction('[Invite Component] SetJobtypes', props<{ jobtypes: Jobtype[] }>());
